import {
  ANALYTICS_SITE_ID,
  ANALYTICS_PAGE_NAME,
  ANALYTICS_CONTENT_TYPE,
  ANALYTICS_TEMPLATE_TYPE,
  FACETS_DATE_PICKER_NAME,
  FACETS_DATE_PICKER_SELECTED_NAME,
} from '../constants';
import { VIEW } from '../../root/actions/_types';

export default ({ state, dispatch }) => {
  // Extract relavent inforamtion from given data object.
  const { pageTitle: title, searchResults = [], searchObj = {}, facets = [] } = state.search || {};

  const { totalResults, currentPage, pageSize } = searchObj;

  // Get all the course ids
  const courseIds = searchResults.map(({ courseId }) => courseId);

  // Create an array of only the facets to be used for analytics
  const selectableFacets = facets.filter((facet) => facet.name !== FACETS_DATE_PICKER_NAME);

  // Store the facet categories that are selected, duplicating them if they contain multiple values.
  const selectedCategories = selectableFacets
    .map((facet) => facet.items.filter((item) => item.selected).map(() => facet.title))
    .reduce((prev, curr) => prev.concat(curr), []);

  // For each facet, create an array of selected facet items. This returns an array of arrays.
  const selectedItems = selectableFacets.map((facet) =>
    facet.items.filter((item) => item.selected),
  );

  // Flatten that array of arrays.
  const selectedItemsFlattened = selectedItems.reduce((prev, curr) => prev.concat(curr), []);

  // Store the selected facet labels.
  const selectedLabels = selectedItemsFlattened.map((item) => item.label);

  const dateFacet = facets.find((facet) => facet.name === FACETS_DATE_PICKER_NAME);
  if (
    dateFacet &&
    dateFacet.items &&
    dateFacet.items[0] &&
    dateFacet.items[0].name !== FACETS_DATE_PICKER_SELECTED_NAME
  ) {
    selectedCategories.push(dateFacet.title);
    selectedLabels.push(dateFacet.items[0].name);
  }

  const viewData = {
    contentType: ANALYTICS_CONTENT_TYPE,
    products: `;${courseIds.join(',;')},`,
    siteId: ANALYTICS_SITE_ID,
    templateType: ANALYTICS_TEMPLATE_TYPE,

    opoFacetCategories: selectedCategories.join('|'),
    opoFacetValues: selectedLabels.join('|'),
    opoSearchPageNum: currentPage,
    opoSearchResults: totalResults,
    opoItemsPerPage: pageSize,

    pageName: `${ANALYTICS_PAGE_NAME}_${title}`,
  };

  return dispatch(VIEW, viewData, { root: true });
};
